import type { ReactElement } from 'react';
import ReactCountryFlag from 'react-country-flag';

/** Template language -> ISO country code for the SVG flag. */
const LANGUAGE_FLAG: Record<string, string> = {
  en: 'GB',
  fr: 'FR',
  it: 'IT',
};

interface LanguageFlagProps {
  language: string;
  size?: number;
}

/**
 * SVG flag for a template language (no emoji, per the project rule). Shared by
 * the template form language select and the send-flow template picker so the
 * language mapping lives in one place.
 */
export function LanguageFlag({ language, size = 16 }: LanguageFlagProps): ReactElement | null {
  const code = LANGUAGE_FLAG[language];
  if (!code) return null;
  return (
    <ReactCountryFlag
      countryCode={code}
      svg
      style={{ width: size, height: size, flexShrink: 0, borderRadius: 2 }}
      title={language}
    />
  );
}
